<template>
  <div>
    <ul class="pagination">
      <div>
        <div
          class="button button--pre"
          v-if="isShowPrevAndNext"
          @click="onPrevFunc()"
        />
      </div>
      <li
        v-for="page in pages"
        :key="page"
        :class="{ active: currentPage == page - 1 }"
        @click="onClickFunc(page)"
      >
        {{ page === -1 ? '···' : page }}
      </li>
      <div
        class="button button--next"
        v-if="isShowPrevAndNext"
        @click="onNextFunc()"
      />
    </ul>
  </div>
</template>

<script>
export default {
  name: 'pagenation',
  props: [
    'isShowPrevAndNext',
    'currentPage',
    'dataLength',
    'displayNumOfEachPage',
    'displayPageTabNum',
    'pages',
  ],
  methods: {
    onPrevFunc() {
      this.$emit('prevClick');
    },
    onNextFunc() {
      this.$emit('nextClick');
    },
    onClickFunc(page) {
      this.$emit('itemClick');
    },
  },
};
</script>

<style lang="scss">
@media screen and (max-width: 768px) {
  .pagination {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .button {
      width: 172px;
      height: 57px;
      background-size: 100%;
      background-repeat: no-repeat;
      &.button--pre {
        background-image: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/m_pre-page.png);
      }
      &.button--next {
        background-image: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/m_next-page.png);
      }
    }

    li {
      text-align: center;
      font-family: 'GenJyuuGothic-P-Regular';
      font-size: 20px;
      line-height: 32px;
      font-weight: normal;
      font-stretch: normal;
      color: #e8cbad;
      padding: 6px 0;
      height: 44px;
      width: 44px;
      margin: 20px 5px;
      border: 1px solid #e8cbad;
      border-radius: 22px;
      cursor: pointer;

      &.active,
      &:hover {
        color: #fff;
        background-color: #e8cbad;
      }
    }
  }
}

// pc
@media screen and (min-width: 769px) {
  .pagination {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .button {
      width: 139px;
      height: 45px;
      background-size: 100%;
      background-repeat: no-repeat;
      &.button--pre {
        background-image: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/pre-page.png);
      }
      &.button--next {
        background-image: url(https://cdn-game-activity.23you.net/frontend/ddj-official-vietnam/assets/next-page.png);
      }
    }

    li {
      text-align: center;
      font-family: 'GenJyuuGothic-P-Regular';
      font-size: 20px;
      line-height: 32px;
      font-weight: normal;
      font-stretch: normal;
      color: #e8cbad;
      padding: 6px 0;
      height: 44px;
      width: 44px;
      margin: 20px 10px;
      border: 1px solid #e8cbad;
      border-radius: 22px;
      cursor: pointer;

      &.active,
      &:hover {
        color: #fff;
        background-color: #e8cbad;
      }
    }
  }
}
</style>